// Sesi login SIMUTU. Angka berpasangan dengan backend/server.py (IDLE_LIMIT, REFRESH_AFTER, SESSION_MAX);
// ubah keduanya bersamaan (backend/tests/test_session.py memeriksanya). Semua hitungan memakai selisih
// jam lokal perangkat, tidak dibandingkan dengan jam server, jadi jam HP/PC yang salah tidak berpengaruh.
// Modul ini sengaja tanpa import agar bisa dites langsung dengan jest.
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
export const REFRESH_AFTER_MS = 5 * 60 * 1000;
export const SESSION_MAX_MS = 12 * 60 * 60 * 1000;
export const MAX_WARN_MS = 5 * 60 * 1000; // peringatan sebelum batas 12 jam
export const IDLE_WARN_MS = 60 * 1000; // peringatan sebelum logout idle
export const ACTIVITY_WRITE_MS = 15 * 1000;
// Gerakan mouse saja sengaja tidak dihitung.
export const ACTIVITY_EVENTS = ["pointerdown", "keydown", "scroll", "wheel", "touchstart"];

export const KEYS = {
  token: "simutu_token",
  tokenAt: "simutu_token_at", // jam lokal saat permintaan token dikirim
  sessionEnd: "simutu_session_end", // jam lokal perkiraan batas 12 jam
  activity: "simutu_last_activity", // dibagi semua tab
  logout: "simutu_logout", // ditulis saat logout -> storage event di tab lain
};

// Halaman yang tidak pernah dialihkan ke /login oleh urusan sesi.
const PUBLIC_PAGES = ["/login", "/lapor-siport"];
export const isPublicPage = (path) => PUBLIC_PAGES.some((p) => path === p || path.startsWith(`${p}/`));
export const isPublicApi = (url = "") => url.startsWith("/public/");
export const loginUrl = (reason) => (reason === "sesi" ? "/login?sesi=berakhir" : "/login");

export function sessionPhase({ now, lastActivity, sessionEnd }) {
  const idleLeft = lastActivity + IDLE_LIMIT_MS - now;
  const maxLeft = sessionEnd - now;
  let phase = "ok";
  if (idleLeft <= 0 || maxLeft <= 0) phase = "expired";
  else if (maxLeft <= MAX_WARN_MS && maxLeft <= idleLeft) phase = "max-warn";
  else if (idleLeft <= IDLE_WARN_MS) phase = "idle-warn";
  return { phase, idleLeft, maxLeft };
}

export const needsRefresh = (now, tokenAt) => now - tokenAt >= REFRESH_AFTER_MS;

export function readSession(now = Date.now()) {
  return {
    tokenAt: Number(localStorage.getItem(KEYS.tokenAt)) || 0,
    sessionEnd: Number(localStorage.getItem(KEYS.sessionEnd)) || Infinity,
    lastActivity: Number(localStorage.getItem(KEYS.activity)) || now,
  };
}

// sentAt = jam lokal sebelum permintaan dikirim, supaya umur token tidak pernah dihitung terlalu muda.
export function saveSession(data, sentAt) {
  localStorage.setItem(KEYS.token, data.token);
  localStorage.setItem(KEYS.tokenAt, String(sentAt));
  if (data.session_expires_in != null) {
    localStorage.setItem(KEYS.sessionEnd, String(sentAt + data.session_expires_in * 1000));
  }
}

export const markActivity = (now = Date.now()) => localStorage.setItem(KEYS.activity, String(now));

// reason "sesi" = berakhir otomatis (idle, 12 jam, atau 401); selain itu logout biasa.
export function endSession(reason) {
  Object.values(KEYS).forEach((k) => localStorage.removeItem(k));
  localStorage.setItem(KEYS.logout, JSON.stringify({ at: Date.now(), reason }));
  if (!isPublicPage(window.location.pathname)) window.location.href = loginUrl(reason);
}
